import { render, staticRenderFns } from "./bed-doubled.vue?vue&type=template&id=d9350d2a&scoped=true&"
import script from "./bed-doubled.vue?vue&type=script&lang=js&"
export * from "./bed-doubled.vue?vue&type=script&lang=js&"
import style0 from "./bed-doubled.vue?vue&type=style&index=0&id=d9350d2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9350d2a",
  null
  
)

export default component.exports